import React, { useRef, useState } from 'react';
import { dealMgmt } from '../../services/dealManagementApi';

/**
 * Upload a director blacklist Excel file from any form.
 * Updates the shared director register used by ID lookup.
 */
export default function DirectorExcelUpload({ showToast, onImported, compact = false }) {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [info, setInfo] = useState('');

  const importExcel = async (file) => {
    if (!file || busy) return;
    setBusy(true);
    setInfo('');
    try {
      const res = await dealMgmt.importDirectorsExcel(file);
      const msg = `Loaded ${res.imported} row(s): ${res.inserted} new, ${res.updated} updated`;
      setInfo(msg);
      showToast?.(msg);
      onImported?.(res);
    } catch (e) {
      setInfo(e.message);
      showToast?.(e.message, 'error');
    } finally {
      setBusy(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  };

  return (
    <div
      className={compact ? undefined : 'ops-inset'}
      style={compact ? {
        marginBottom: 12,
        padding: '10px 12px',
        border: '1px solid var(--border)',
        borderRadius: 10,
        background: 'var(--surface2)',
      } : { marginBottom: 14 }}
    >
      <div style={{ fontWeight: 650, fontSize: 12.5, marginBottom: 4 }}>
        Upload director Excel
      </div>
      <div style={{ fontSize: 11.5, color: 'var(--text3)', marginBottom: 8, lineHeight: 1.4 }}>
        Use columns like <strong>ID number</strong>, <strong>Name</strong>, <strong>Status</strong>
        (blacklisted / watchlist / clear). Then enter an ID below to check status.
        {' '}
        <a href="/director-register-template.xlsx" download style={{ color: 'var(--brand)', fontWeight: 650 }}>
          Download template
        </a>
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
        <input
          ref={fileRef}
          type="file"
          accept=".xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
          disabled={busy}
          onChange={(e) => importExcel(e.target.files?.[0])}
        />
        {busy && <span style={{ fontSize: 12, color: 'var(--text3)' }}>Uploading…</span>}
      </div>
      {info && (
        <div style={{ marginTop: 8, fontSize: 12, color: 'var(--text2)' }}>{info}</div>
      )}
    </div>
  );
}
